import { getUser } from "../services/Auth";
import api from "./api";

export const ListarDestaques = async () => {
  try {
    const usuario = await getUser();
    const corredores = await api.get(
      `/estabelecimentos/${usuario.estabelecimento._id}/destaques`,
    );
    return corredores.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarDestaques = async (data) => {
  try {
    const destaques = await api.post(`/destaques`, data);
    return destaques.data;
  } catch (error) {
    throw error;
  }
};

export const EditarDestaque = async (data, id) => {
  try {
    const destaques = await api.put(`/destaques/${id}`, data);
    return destaques.data;
  } catch (error) {
    throw error;
  }
};

export const DeletarDestaque = async (id) => {
  try {
    const destaques = await api.delete(`/destaques/${id}`);
    return destaques.data;
  } catch (error) {
    throw error;
  }
};
